// extracted by mini-css-extract-plugin
export default {"relatedcontent":"RelatedContent_relatedcontent__C-qRA","itemsWrapper":"RelatedContent_itemsWrapper__YSR4V"};